export default "__VITE_ASSET__NVmbPaT8__"